export default __webpack_public_path__ + "static/media/rescue-slots-ico.438c7a20.svg";